import { Sun, Moon } from "lucide-react";
import { Section, Headline, Reveal } from "@/components/primitives";
import { about } from "@/config";

const Points = ({ items }) => (
  <ul className="mt-6 space-y-3">
    {items.map((it) => (
      <li key={it} className="flex items-center gap-3 text-[15px] text-gray2">
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-oxblood" aria-hidden="true" /> {it}
      </li>
    ))}
  </ul>
);

export default function About() {
  return (
    <Section id="about" tone="charcoal">
      <Reveal>
        <Headline>{about.headline}</Headline>
        <div className="hairline mt-5 w-16" aria-hidden="true" />
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2">
        <Reveal>
          <div data-testid="about-day-card" className="card h-full rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h3 className="font-serif text-xl text-cream">{about.day.title}</h3>
              <Sun className="h-5 w-5 shrink-0 text-gold" />
            </div>
            <Points items={about.day.points} />
            <p className="mt-6 text-sm font-light text-gray2/80">{about.day.line}</p>
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <div
            data-testid="about-night-card"
            className="h-full rounded-xl border border-oxblood/40 bg-noir/60 p-8"
            style={{ boxShadow: "inset 0 0 50px rgba(110,30,40,0.12), 0 0 34px rgba(110,30,40,0.12)" }}
          >
            <div className="flex items-center justify-between">
              <h3 className="font-serif text-xl text-cream">{about.night.title}</h3>
              <Moon className="h-5 w-5 shrink-0 text-cream/70" />
            </div>
            <Points items={about.night.points} />
            <p className="mt-6 text-sm font-light italic text-cream/80">{about.night.line}</p>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
